export enum DiscountMode {
  Percentage = 1,
  Monetary = 2
};
